import styled from 'styled-components';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const InputWrapper = styled.div`
  margin-bottom: 20px;
`;
